import React from 'react';
import styled, { css } from 'styled-components';
import { TABLET_TEXT_WIDTH, LAPTOP_TEXT_WIDTH, FULLHD_TEXT_WIDTH } from '@constants/params';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { textSize, Points, marginLevel, paddingLevel } from '@styles';

export const Bluebox = ({ html = '', children }) => (
  <>{html ? <View dangerouslySetInnerHTML={{ __html: html }} /> : <View>{children}</View>}</>
);

export const styles = {
  container: css`
    ${paddingLevel('both', 'accent_block')};
    ${marginLevel('both', 'accent_outer')};
    padding-left: 16px;
    padding-right: 16px;
    background-color: ${Colors.main_beige};

    .visual-heading,
    strong {
      ${textSize('card_header')};
      margin-bottom: 10px;
      color: ${Colors.main_dark};
      display: block;
      font-weight: 300;
    }

    b {
      font-weight: 400;
    }

    p {
      width: 100%;
      ${textSize('body')};
      font-weight: 400;
      color: ${Colors.main_gray};
      padding: 0;
      margin-left: 0;
      margin-right: 0;

      &:last-child {
        margin-bottom: 0;
      }
    }

    p > strong {
      display: inline;
      font-weight: 500;
      ${textSize('body')};
    }

    .bluebox-button {
      width: 100%;
      height: 38px;
      margin: 30px 0 15px 0;
      padding: 16px 20px 16px 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      outline: none;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      border-radius: 9px;
      box-sizing: border-box;
      text-decoration: none;
      transition-property: background-color, border-color, box-shadow, background-position;
      transition-duration: 0.3s;
      transition-timing-function: ease;
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -webkit-tap-highlight-color: transparent;
      touch-action: none;

      &:focus,
      &:active {
        outline: none;
        box-shadow: none;
      }

      &:first-child {
        margin-top: 30px;
      }

      &.primary {
        color: ${Colors.white};
        background-color: ${Colors.main_dark};
      }

      &.primary:hover {
        box-shadow: 1px 1px 3px 0px ${Colors.main_dark}14, 3px 4px 5px 0px ${Colors.main_dark}12,
          6px 9px 7px 0px ${Colors.main_dark}0A, 11px 16px 8px 0px ${Colors.main_dark}03,
          17px 25px 8px 0px ${Colors.main_dark}00;
      }

      &.primary:active {
        background-color: ${Colors.main_black};
      }

      &.secondary {
        border: 1px solid ${Colors.main_gray};
        color: ${Colors.main_dark};
      }

      &.secondary:hover {
        box-shadow: 1px 1px 3px 0px ${Colors.main_dark}14, 3px 4px 5px 0px ${Colors.main_dark}12,
          6px 9px 7px 0px ${Colors.main_dark}0A, 11px 16px 8px 0px ${Colors.main_dark}03,
          17px 25px 8px 0px ${Colors.main_dark}00;
      }

      &.secondary:active {
        border: 1px solid ${Colors.main_black};
        color: ${Colors.main_black};
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    .bluebox-button-wrapper {
      margin-top: 30px;
    }

    .bluebox-button-wrapper .bluebox-button {
      margin-top: 0;
      margin-bottom: 0;
    }

    .bluebox-button-wrapper .bluebox-button:not(:first-child) {
      margin-top: 10px;
    }

    @media ${Points.tablet_portrait} {
      width: ${TABLET_TEXT_WIDTH};
      padding-left: 25px;
      padding-right: 25px;
      margin-left: auto;
      margin-right: auto;

      .bluebox-button {
        width: 210px;
        height: 50px;
        margin: 30px 15px 0 0;
        font-size: 16px;
        line-height: 18px;
      }

      .bluebox-button-wrapper {
        display: flex;
        margin-top: 30px;
      }

      .bluebox-button-wrapper .bluebox-button,
      .bluebox-button-wrapper .bluebox-button:not(:first-child) {
        margin-top: 0;
      }
    }

    @media ${Points.laptop} {
      width: ${LAPTOP_TEXT_WIDTH};
      padding-left: 30px;
      padding-right: 30px;

      .bluebox-button {
        width: 228px;
      }
    }

    @media ${Points.fullhd} {
      width: ${FULLHD_TEXT_WIDTH};
      padding-left: 35px;
      padding-right: 35px;

      .bluebox-button {
        margin: 40px 15px 0 0;
      }

      .bluebox-button-wrapper {
        margin-top: 40px;
      }

      .bluebox-button-wrapper .bluebox-button {
        margin-top: 0;
      }
    }
  `,
};

export const View = styled.div`
  ${styles.container};
`;
